var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label>\n  <input type="checkbox" data-title="'+
((__t=( id ))==null?'':_.escape(__t))+
'" /> '+
((__t=( title ))==null?'':__t)+
'\n</label>\n';
}
return __p;
};
